import React from 'react'
import { Col, Row, Container } from 'reactstrap'
import styled from 'styled-components'
import colors from 'constants/colors'
import appScreenshots from 'assets/img/app-screenshots-v2.png'
import { LoadingProvider } from 'components/common/Loading'

const StyledContainer = styled(Container)`
  background-color: white;
`

const StyledDisplayCol = styled(Col)`
  background-color: #f4f4f5;
  min-height: 100vh;
  height:100%;
`

const DisplayTitle = styled.h1`
  font-family: Poppins;
  font-weight: 600;
  font-size: 44px;
  color: ${colors.black};
  margin-top: 15px;
`

const DisplaySubtitle = styled.p`
  font-family: Poppins;
  font-weight: 500;
  font-size: 14px;
  color: ${colors.grey};
  margin-bottom: 25px;
  margin-top: 15px;
`

const DisplayWrapper = styled.div`
  padding: 8rem;
  text-align:center;
`

const AuthBasicLayout: React.FC = ({ children }) => (
  <StyledContainer fluid className="p-0">
    <Row className="no-gutters">
      <Col xs="12" sm="12" md="12" lg="5" className="text-center p-5">
        <LoadingProvider>
          { children }
        </LoadingProvider>
      </Col>
      <StyledDisplayCol xs="12" sm="12" md="12" lg="7">
        <DisplayWrapper>
          <img
            alt="Bird Level Screenshots"
            src={appScreenshots}
            className="section mb-3 hidden-md-down"
            style={{ width: '700px' }}
          />
          <DisplayTitle
            className="align-text-bottom"
          >
            The best way to get back up and running
          </DisplayTitle>
          <DisplaySubtitle
            className="align-text-bottom"
          >
            BirdLevel is the simple solution to bring people back safely.
          </DisplaySubtitle>

        </DisplayWrapper>
      </StyledDisplayCol>
    </Row>
  </StyledContainer>
)

export default AuthBasicLayout
